import { render, staticRenderFns } from "./AxPanel.vue?vue&type=template&id=35f75a32&scoped=true&"
import script from "./AxPanel.vue?vue&type=script&lang=js&"
export * from "./AxPanel.vue?vue&type=script&lang=js&"
import style0 from "./AxPanel.vue?vue&type=style&index=0&id=35f75a32&lang=scss&scoped=true&"
import style1 from "./AxPanel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f75a32",
  null
  
)

export default component.exports